var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tools-box"},[_c('i',{staticClass:"btn iconfont icon-dianhua",on:{"click":_vm.clickPhone}}),_c('i',{staticClass:"btn iconfont icon-zhifeiji",on:{"click":_vm.gotoMap}})]),(_vm.showMap)?_c('Maps',{on:{"gotoCom":_vm.gotoCom}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }